import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=7399ff79&scoped=true"
import script from "./iconfont.vue?vue&type=script&lang=js"
export * from "./iconfont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399ff79",
  null
  
)

export default component.exports